'use client';

import QueryProvider from '@/providers/query-provider';

export default function LayoutContent({
  children
}: {
  children?: React.ReactNode;
}) {
  return (
    <QueryProvider>
      <main>{children}</main>
    </QueryProvider>
  );
}
